"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var color_1 = require("../utilities/color");
var stack_container_1 = __importStar(require("./stack-container"));
var i18next_1 = __importDefault(require("i18next"));
var NameContainer = /** @class */ (function (_super) {
    __extends(NameContainer, _super);
    function NameContainer(textures) {
        var _this = _super.call(this) || this;
        _this._textures = textures;
        _this.addChild(_this.stackContainer);
        return _this;
    }
    Object.defineProperty(NameContainer.prototype, "titleLabel", {
        get: function () {
            if (!this._titleLabel) {
                this._titleLabel = new PIXI.Text("");
                this._titleLabel.style = {
                    fontFamily: "Arial",
                    fontWeight: "bold",
                    fill: color_1.COLOR.WHITE
                };
            }
            return this._titleLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NameContainer.prototype, "gemSprites", {
        get: function () {
            if (!this._gemSprites) {
                this._gemSprites = [];
                for (var i = 0; i < this.maxGems; i++) {
                    this._gemSprites.push(new PIXI.Sprite());
                }
            }
            return this._gemSprites;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NameContainer.prototype, "gemsContainer", {
        get: function () {
            if (!this._gemsContainer) {
                this._gemsContainer = new stack_container_1.default([], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.HORIZONTAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: -2
                });
            }
            return this._gemsContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NameContainer.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.titleLabel,
                    this.gemsContainer
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 4
                });
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NameContainer.prototype, "maxGems", {
        get: function () {
            return this._maxGems;
        },
        set: function (value) {
            if (this._maxGems == value) {
                return;
            }
            this._maxGems = value;
            this._gemSprites = null;
            this.gemsContainer.arrangedChildren = this.gemSprites;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NameContainer.prototype, "currentGems", {
        get: function () {
            return this._currentGems;
        },
        set: function (value) {
            this._currentGems = value;
            for (var i = 0; i < this.gemsContainer.children.length; i++) {
                this.gemsContainer.children[i].texture = i <= value ? this._textures["gem_on.png"] : this._textures["gem_off.png"];
            }
            this.gemsContainer.layoutChildren();
        },
        enumerable: false,
        configurable: true
    });
    NameContainer.prototype.setTitle = function (title, large, currentGems) {
        this.titleLabel.style.fontSize = large ? 29 : 19;
        this.titleLabel.text = (title === null || title === void 0 ? void 0 : title.trim()) ? title : i18next_1.default.t("name_none");
        this.currentGems = currentGems;
        this.stackContainer.layoutChildren();
    };
    return NameContainer;
}(PIXI.Container));
exports.default = NameContainer;
